import React, { useState } from 'react'
import { motion } from 'framer-motion'

interface BeastImageProps {
  beastName: string
  description: string
  className?: string
}

const BeastImage: React.FC<BeastImageProps> = ({ beastName, className = "" }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)

  // Placeholder images - in a real implementation, these would be AI-generated
  const getPlaceholderImage = (beastName: string) => {
    const imageMap: { [key: string]: string } = {
      'Lion with Eagle\'s Wings': '/images/lion-with-eaglewings.png',
      'Bear Raised on One Side': '/images/bear-creature.png', 
      'Leopard with Four Wings and Four Heads': '/images/leopard-with-4-wings.png',
      'Terrifying Beast with Iron Teeth and Ten Horns': '/images/fourth beast-1.png'
    }
    return imageMap[beastName] || '/images/the-four-beasts.png'
  }

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  const handleImageError = () => {
    setImageError(true)
  }

  return (
    <div className={`relative overflow-hidden rounded-lg ${className}`}>
      {!imageError ? (
        <motion.img
          src={getPlaceholderImage(beastName)}
          alt={beastName}
          className="w-full h-full object-cover"
          onLoad={handleImageLoad}
          onError={handleImageError}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ 
            opacity: imageLoaded ? 1 : 0,
            scale: imageLoaded ? 1 : 1.1
          }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center">
          <div className="text-center text-gray-400">
            <div className="text-4xl mb-2">🦁</div>
            <div className="text-sm">{beastName}</div>
          </div>
        </div>
      )}
      

      {/* Loading indicator */}
      {!imageLoaded && !imageError && (
        <div className="absolute inset-0 bg-slate-800 flex items-center justify-center">
          <motion.div
            className="w-8 h-8 border-2 border-bible-gold border-t-transparent rounded-full"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
        </div>
      )}
    </div>
  )
}

export default BeastImage

